// CursorManager.js
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
var CursorManager = /*#__PURE__*/ function() {
    "use strict";
    function CursorManager() {
        var startX = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, startY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        _class_call_check(this, CursorManager);
        this.x = startX;
        this.y = startY;
        this.lineHeight = 20; // default
        this.lastHeight = this.lineHeight;
    }
    _create_class(CursorManager, [
        {
            // ===== Get / Set =====
            key: "GetX",
            value: function GetX() {
                return this.x;
            }
        },
        {
            key: "GetY",
            value: function GetY() {
                return this.y;
            }
        },
        {
            key: "SetX",
            value: function SetX(x) {
                this.x = x;
            }
        },
        {
            key: "SetY",
            value: function SetY(y) {
                this.y = y;
            }
        },
        {
            key: "SetXY",
            value: function SetXY(x, y) {
                this.x = x;
                this.y = y;
            }
        },
        {
            // ===== Ln =====
            key: "Ln",
            value: function Ln() {
                var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                this.y += h || this.lastHeight || this.lineHeight;
                this.x = 0;
            }
        },
        {
            // ===== Helper คำนวณจำนวนบรรทัด =====
            key: "calcLines",
            value: function calcLines(text, width) {
                var charPerLine = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 20;
                // charPerLine สามารถปรับเป็นความกว้างจริงตาม fontSize
                var lines = [];
                var currentLine = "";
                var words = text.split(" ");
                words.forEach(function(word) {
                    if ((currentLine + word).length > charPerLine) {
                        lines.push(currentLine.trim());
                        currentLine = word + " ";
                    } else {
                        currentLine += word + " ";
                    }
                });
                if (currentLine) lines.push(currentLine.trim());
                return lines;
            }
        },
        {
            // ===== Cell แบบ AutoHeight =====
            key: "Cell",
            value: function Cell(width) {
                var text = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.lineHeight, fontSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 12;
                // คำนวณ actualHeight จากข้อความ
                var charPerLine = Math.floor(width / (fontSize * 0.6)); // ประมาณ
                var lines = this.calcLines(text, width, charPerLine);
                var actualHeight = lines.length * this.lineHeight;
                var pos = {
                    x: this.x,
                    y: this.y,
                    width: width,
                    height: actualHeight,
                    lines: lines
                };
                // เลื่อนไปขวา
                this.x += width;
                this.lastHeight = actualHeight;
                return pos;
            }
        },
        {
            // ===== MultiCell แบบ AutoHeight =====
            key: "MultiCell",
            value: function MultiCell(width) {
                var text = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.lineHeight, fontSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 12;
                var charPerLine = Math.floor(width / (fontSize * 0.6));
                var lines = this.calcLines(text, width, charPerLine);
                var actualHeight = lines.length * this.lineHeight;
                var pos = {
                    x: this.x,
                    y: this.y,
                    width: width,
                    height: actualHeight,
                    lines: lines
                };
                // เลื่อนลงบรรทัดใหม่
                this.y += actualHeight;
                this.x = 0;
                this.lastHeight = actualHeight;
                return pos;
            }
        }
    ]);
    return CursorManager;
}();
export { CursorManager as default };
